import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HeaderWithDropdown from './components/HeaderWithDropdown';
import Hero from './components/Hero';
import Services from './components/Services';
import ValueProposition from './components/ValueProposition';
import AICapabilities from './components/AICapabilities';
import WhyChooseUs from './components/WhyChooseUs';
import Industries from './components/Industries';
import Stats from './components/Stats';
import Contact from './components/Contact';
import Testimonials from './components/Testimonials';
import ClientLogos from './components/ClientLogos';
import Footer from './components/Footer';
import ServiceDetail from './pages/ServiceDetail';
import About from './pages/About';
import IndustriesPage from './pages/Industries';
import ContactPage from './pages/ContactPage';
import Products from './pages/Products';
import Careers from './pages/Careers';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import { Toaster } from './components/ui/toaster';

const Home = () => {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Handle hash navigation on load
    if (window.location.hash) {
      setTimeout(() => {
        const element = document.querySelector(window.location.hash);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen">
      <main>
        <Hero />
        <ValueProposition />
        <Services />
        <AICapabilities />
        {/* <Stats /> */}
        <WhyChooseUs />
        {/* <ClientLogos /> */}
        {/* <Testimonials /> */}
        <Industries />
        <Contact />
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <HeaderWithDropdown />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
        <BackToTop />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
